import { motion } from "framer-motion";

const roles = [
  {
    period: "Jan 2025 — Present",
    company: "Pacific Iron Manufacturing Ltd.",
    group: "JP Aggarwal Group",
    role: "PMC Head",
    note: "Leading PMC operations for a ₹3,200+ Cr integrated steel plant program — end-to-end planning, statutory readiness, board MIS and multi-vendor governance.",
  },
  {
    period: "Apr 2018 — Jan 2025",
    company: "JK Cement Ltd.",
    group: "YP Singhania Group",
    role: "Manager → Senior Manager → Deputy General Manager · Project Planning",
    note: "Progressive elevation across Power Plant + WHRS, Warehouse & Industrial Infrastructure, Township & Villas, and finally DGM — directing 10+ concurrent cement manufacturing programs (₹1,800 – ₹2,300 Cr each). Recovered a 26-day schedule delay applying CCPM.",
  },
  {
    period: "Oct 2007 — Mar 2018",
    company: "UltraTech Cement Ltd.",
    group: "Aditya Birla Group",
    role: "Senior Engineer → Assistant Manager · Project Planning & Maintenance",
    note: "A decade with the Aditya Birla Group across Bulk Terminals, Grinding Units and the Integrated Cement Plant — Pearl Project (₹2,350 Cr) commissioned in 364 days. Cost savings of ~₹3.7 Cr and 36-day delay recovery.",
  },
  {
    period: "Oct 2005 — Sep 2007",
    company: "Binani Cement Ltd.",
    group: "Binani Group",
    role: "Engineer · Project Execution",
    note: "First professional practice: site execution, contractor coordination and mechanical commissioning of core cement plant equipment.",
  },
];

const row = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.9, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Timeline() {
  return (
    <section id="career" className="relative border-b border-surface-2 bg-[#0b1a30]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 py-28 md:py-40">
        <div className="grid grid-cols-12 gap-6 items-end mb-16">
          <div className="col-span-12 md:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.28em] text-brass">
              <span className="tabular">08 —</span><span className="ml-3">A Life of Programs</span>
            </div>
            <h2 className="mt-4 font-serif-display font-light text-ivory text-5xl md:text-6xl leading-[0.95] tracking-[-0.02em]">
              Four groups.<br />
              <span className="italic text-brass">One discipline.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 text-mutedfg text-sm md:text-base font-light leading-relaxed">
            Oct 2005 to present — an unbroken practice across four listed / promoter-led industrial groups.
            Progression by scope, sector and stakeholder complexity — not by title alone.
          </div>
        </div>

        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-1 hidden md:block relative">
            <div className="absolute left-2 top-2 bottom-2 w-px bg-surface-2" />
          </div>

          <div className="col-span-12 md:col-span-11">
            {roles.map((r, i) => (
              <motion.div
                key={r.role}
                custom={i}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-60px" }}
                variants={row}
                className="relative grid grid-cols-12 gap-6 py-10 border-b border-surface-2"
              >
                <div className="absolute -left-[22px] top-12 hidden md:block">
                  <span className="block h-2 w-2 bg-brass pulse-dot" />
                </div>
                <div className="col-span-12 md:col-span-3 text-[11px] uppercase tracking-[0.22em] text-brass tabular">
                  {r.period}
                </div>
                <div className="col-span-12 md:col-span-4">
                  <div className="font-serif-display text-ivory text-2xl md:text-3xl font-light leading-tight">
                    {r.company}
                  </div>
                  <div className="mt-2 text-mutedfg text-sm">{r.group}</div>
                </div>
                <div className="col-span-12 md:col-span-5">
                  <div className="text-ivory text-base md:text-lg font-light">{r.role}</div>
                  <p className="mt-3 text-mutedfg leading-relaxed font-light">{r.note}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
